import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getChildbirthOBSelector } from '../../procedures/childbirthOB/selectors'
import { IChildbirthOBState } from '../../procedures/childbirthOB/store/childbirthOB.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'

export function* addChildbirthOBItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  const { items } = timeline
  const childbirthOBState: IChildbirthOBState = yield select(getChildbirthOBSelector)
  const {
    pta,
    addToTimeline,
    action,
    fetalHR,
    contractionsDur,
    contractionsFreq,
    variability,
    accelerations,
    deceleration,
    uCStrength,
    dTR,
    key,
    time,
    date,
    assessedBy,
    attempts,
    successfulAttempt,
    comments,
    isEkgImport,
  } = childbirthOBState
  if (addToTimeline) {
    const clientCorrelationId = generateClientCorrelationId(
      nemsisCodeOptions,
      TimelineConstants.CHILDBIRTH_PROCEDURE,
      action?.name || '',
      {
        filter1: null,
        filter2: null,
        filter3: null,
      },
      key
    )
    const successfulAttemptLabel = successfulAttempt ? 'Yes' : 'No'
    const showFetalAssessmentFields = action?.name === 'Fetal Assessment'
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      clientCorrelationId,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Childbirth / OB',
      eventSubHeader: `By ${assessedBy?.name || ''}, Action: ${action?.name || ''}, Fetal HR: ${fetalHR},
      Contractions Freq: ${contractionsFreq}, Contractions Dur: ${contractionsDur},
      ${showFetalAssessmentFields ? 'Variability: ' + (variability?.name || '') + ', ' : ''}
      ${showFetalAssessmentFields ? 'Accelerations: ' + (accelerations?.name || '') + ', ' : ''}
      ${showFetalAssessmentFields ? 'Deceleration: ' + (deceleration?.name || '') + ', ' : ''}
      ${showFetalAssessmentFields ? 'UC Strength: ' + (uCStrength?.name || '') + ', ' : ''}
      ${showFetalAssessmentFields ? 'DTR: ' + (dTR?.name || '') + ', ' : ''}
      Attempts: ${attempts}, Success: ${successfulAttemptLabel}, Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_CHILDBIRTHOB_PROCEDURE_ITEM,
      defaultHref: TabConstants.CHILDBIRTHOB_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addChildbirthOBItemSaga() {
  yield takeLatest([TimelineConstants.ADD_CHILDBIRTHOB_ITEM], addChildbirthOBItem)
}
